<template>
		<v-dialog v-model="dialog" max-width="600" >
			<template v-slot:activator="{ on }">
				<v-btn  color="primary" v-on="on" >
					<v-icon> mdi-url </v-icon> Abrir anexos importantes
				</v-btn>
			</template>
			<v-card outlined class="">
				<v-card-title>
					<v-row dense>
						Anexos importantes
						<v-spacer></v-spacer>
						<v-btn  color="primary" small icon @click="dialog=false" >
							<v-icon> mdi-close </v-icon>
						</v-btn>
					</v-row>
				</v-card-title>
				<v-card-text>
					<div v-if="$store.globalStore.state.loading">
						Carregando Anexos... <v-progress-circular indeterminate size="30"></v-progress-circular>
					</div>
					<div class="mt-4 mb-4" v-for="categoria, idx_cat in computed_categoria_anexos" :key="'categoria_anexos_'+idx_cat">
						<label class="subtitle-1"><strong>{{categoria}}</strong></label>
						<v-divider></v-divider>
						<div class="my-1" v-for="anexo, index in (computedSettings.get_anexos || [])" 
							:key="'anexo_'+index">
							<v-btn v-if="anexo.get_categoria.descricao == categoria" text outlined small block :href="anexo.link" target="_blank" color="primary">
								{{anexo.descricao}} 
							</v-btn>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
</template>

<script>

export default {
	name: 'Links',
	props:{
	},
	data () {
		return {
			dialog: false,
		}        
	},
	computed:{
		computed_categoria_anexos(){
			let cat = []
			if (this.computedSettings && this.computedSettings.get_anexos){
				// mapear um array de descrição de categorias
				cat = this.computedSettings.get_anexos.map(obj=> obj.get_categoria.descricao)

				// remover duplicados
				cat = cat.filter((list, index, item) => {
					return item.indexOf(list) === index
				})
			}
			return cat
		},
		computedContextoSelecionado(){
            return this.$store.globalStore.getters.getContexto
        },
		computedSettings(){
            // return this.$store.globalStore.getters.getContexto && this.$store.globalStore.getters.getContexto.id ?
			// 			this.$store.globalStore.getters.getContexto.get_configuracao : {}
			return this.computedContextoSelecionado.get_configuracao || {}
        },
		contextoIsSelected(){
            return this.computedContextoSelecionado && this.computedContextoSelecionado.id
        }

	},
	methods:{
		
	},
	mounted(){
	}
}
</script>